import React from 'react';
import { promises } from '../data/promises';
export function Promises() {
  return <section id="why" className="w-full bg-white py-16 lg:py-24" data-id="element-50" data-mp="2uinjm62v2a16">
      <div className="mx-auto w-full max-w-7xl px-5 lg:px-10" data-id="element-51" data-mp="2ugarx17awlax">
        <h2 className="font-heading text-4xl font-black uppercase leading-none tracking-tight text-[#0B1B3A] lg:text-5xl" data-id="element-52" data-mp="398cvav8kxwfp">
          Three promises,
          <br data-id="element-53" data-mp="34eqlrbxpq8o4" />
          every single job.
        </h2>

        <div className="mt-12 grid gap-6 md:grid-cols-3" data-id="element-54" data-mp="3i6ojkqlz4i4z">
          {promises.map((promise, index) => <article key={promise.title} className="border-4 border-[#0B1B3A] bg-white p-7" data-id="element-55" data-mp="3d8daii3i6bnt" data-mpi={index}>
              <span className="font-heading text-5xl font-black leading-none text-[#FACC15]" data-id="element-56" data-mp="3n72vwkulye8t">
                {String(index + 1).padStart(2, '0')}
              </span>
              <h3 className="mt-5 font-heading text-2xl font-black uppercase tracking-tight text-[#0B1B3A]" data-id="element-57" data-mp="1xsejijm0owas">
                {promise.title}
              </h3>
              <p className="mt-3 leading-relaxed text-[#0B1B3A]/70" data-id="element-58" data-mp="2wx9uflpdugk0">
                {promise.description}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}